/**
 * Joins a taxa path into a map or cache key. U+0001 cannot occur in a taxon name; a printable
 * delimiter can (`Bacteroidetes/Chlorobi group`, `Chironomus sp.`) and lets two distinct lineages
 * share one key. Spelled as an escape — a raw control byte makes the file binary to git, which costs
 * a readable diff and a 3-way merge.
 */
const SEPARATOR = '\u0001'

export const taxaPathKey = (taxa: readonly string[]): string => taxa.join(SEPARATOR)
